<template>
  <div v-rect-loading="loading" class="email-template-list">
    <TableList
      noHead
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
    >
    </TableList>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.company.onboarding.label.emailSubject'),
          dataKey: 'subject',
          width: '300px'
        },
        {
          label: this.$t('admin.company.onboarding.label.emailType'),
          dataKey: 'type',
          width: '100px',
          formatter: (data) => {
            switch (data) {
              case 1:
              case '1':
                return this.$t('admin.company.onboarding.emailTemplateType.invitation')
              case 2:
              case '2':
                return this.$t('admin.company.onboarding.emailTemplateType.reminder')
              case 3:
              case '3':
                return this.$t('admin.company.onboarding.emailTemplateType.onboardingFinished')
              default:
                return '-'
            }
          }
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          isShow: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('onboardingManagement', ['searchEmailTemplate']),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchEmailTemplate()
        if (resp && resp.emailTemplates) {
          this.listData = resp.emailTemplates
        }
      } finally {
        this.loading = false
      }
    },
    handleEdit (rowData) {
      this.$router.push(`/v-admin/onboarding-management/email-template/edit/${rowData.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
